export const PermissionsEndpoints = {
    createPermission: {
        method: "post",
        url: "/permissions",
    },
    getAllPermissions: {
        method: "get",
        url: "/permissions",
    },
    getPermission: (id) => ({
        method: "get",
        url: `/permissions/${id}`,
    }),
    updatePermission: (id) => ({
        method: "put",
        url: `/permissions/${id}`,
    }),
    deletePermission: (id) => ({
        method: "delete",
        url: `/permissions/${id}`,
    }),
}
